import sectionText from '@sections/text'
import abstract from './abstract'

export default class extends abstract {
  getComponent () {
    return sectionText
  }

  get headline () {
    return this.item.properties.titel
  }

  get body () {
    return this.item.properties.indhold
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/text.js